import qs from 'qs';
import { Component, Vue, Watch } from 'vue-property-decorator';

import UinsDefaultSelect from '@/components/unisDefaultSelect';
import UnisProductModal from '@/components/unisProductModal';

import tmsService from '@/services/axios/tmsService';
import tmsServiceBackend from '@/services/axios/tmsServiceBackend';
import tmsTransformRequestService from '@/services/axios/tmsTransformRequestService';
import { LocalStorageCache } from '@/services/cache';
import { TMSCustomerAccountService, TMSCustomerAccountServiceEvent } from '@/services/user';

import template from './tmpl.vue';

const customerAccountService = TMSCustomerAccountService.create({
    cache: LocalStorageCache.create(),
    tmsService: tmsService,
    tmsTransformRequestService: tmsTransformRequestService,
});

@Component({
    components: {
        UnisProductModal,
        UinsDefaultSelect,
    },
    mixins: [template],
})
class C extends Vue {
    isShowNotif: any = false;
    isShowUser: any = false;
    isInSearchBox: any = false;
    isShowShade: any = false;
    contactCupport: any = {
        content: '',
        pro_or_pu: '',
        type_of_inquiry: '',
    };
    billingList: Array<any> = [];
    userBilling: any = '';
    search_text: any = '';
    userName: any = localStorage.getItem('UserFirstLast');
    userNameFirstLetter: string = '';
    editProductModal: string = 'Contactsupport';
    isRouteNameRrackShipmentLoggedIn: any = false;

    @Watch('$route')
    routechange(to: any, from: any) {
        if (to.name == 'trackShipmentLoggedIn') this.isRouteNameRrackShipmentLoggedIn = true;
        else this.isRouteNameRrackShipmentLoggedIn = false;
    }

    created() {
        function getFirstLetterUppercase() {
            let userName = localStorage.getItem('UserFirstLast');
            if (userName) {
                return userName.charAt(0).toUpperCase();
            } else {
                return '';
            }
        }

        this.userNameFirstLetter = getFirstLetterUppercase();
    }

    onShowNotif() {
        this.isShowNotif = true;
        this.isShowUser = false;
        this.isShowShade = true;
    }

    onShowUser() {
        this.isShowNotif = false;
        this.isShowUser = true;
        this.isShowShade = true;
    }

    handleFocus() {
        this.isInSearchBox = true;
    }

    handleBlur() {
        this.isInSearchBox = false;
    }

    onShowShade() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
    }

    logout() {
        this.$store.dispatch('logout');
    }

    async mounted() {
        (window as any).contactupport = this.contactSupport;
        window.addEventListener(
            TMSCustomerAccountServiceEvent.BillToChanged,
            ({ detail }: CustomEvent<any>) => {
                if (this.userBilling === detail.location_id) {
                    return;
                }
                this.userBilling = detail.location_id;
            },
            false
        );
    }

    public changeBillingList(billing: any) {
        console.log('changeBillingList', billing);
        this.$emit('locationChange', billing.location_id);
    }

    contactSupport(
        data: Partial<{
            pro_or_pu: string;
        }> = {}
    ) {
        const { pro_or_pu = '' } = data;

        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        this.contactCupport = {
            content: '',
            pro_or_pu: pro_or_pu,
            title: '',
            type_of_inquiry: '',
        };
        this.$modal.show(this.editProductModal);
    }

    modalHide() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        this.$modal.hide(this.editProductModal);
    }

    send() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        tmsServiceBackend
            .post(`/cpv2/support/contactSupportV2`, qs.stringify(this.contactCupport))
            .then(
                (res: any) => {
                    this.showUpdated({
                        title: 'Contact support send',
                        mag: res.data.message,
                    });
                },
                (err: any) => {
                    this.err(err.data.message);
                }
            );
        this.$modal.hide(this.editProductModal);
    }
}

export default C;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers-details/components/navbar/index.ts